import { useCallback, useEffect, useState } from 'react';
import DsInquiryService from '../../../services/DsInquiry.service';
import DataFlowService from '../../../services/DataFlow.service';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function useDsInquiry(setPagevalue) {
    const [dataSubject, setDataSubject] = useState([]);
    const [dataflowRopa, setDataflowRopa] = useState([]);

    const [loading, setLoading] = useState(false);
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);

    const [status, setStatus] = useState([]);
    const [statusRopa, setStatusRopa] = useState([]);
    const [department, setDepartment] = useState([]);

    const { i18n } = useTranslation();

    const { hash } = useLocation();

    // Get data subject
    const getDataSubject = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await DsInquiryService.getDataSubject();
            if (data?.resultData) {
                const uniqueResultData = [...new Set(data?.resultData)];
                setDataSubject(uniqueResultData);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }, []);

    // Get category personal data
    const getCategoryPersonalData = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await DsInquiryService.getCategoryPersonalData();
            if (data?.resultData) {
                const resultData = data?.resultData.map((item) => {
                    return {
                        ...item,
                        categoryPersonalDataId: item.categoryPersonalDataIds[0],
                    };
                });
                setDataSubject(resultData);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }, []);

    // Get data flow
    const getDataFlow = useCallback(async (params) => {
        setLoadingDetail(true);
        setDataflowRopa([]);
        try {
            const { data } = await DsInquiryService.getDataFlow(params);
            if (data?.resultData) {
                setDataflowRopa(data.resultData.result);
                setLoadingDetail(false);
                const pagevalue = {
                    p: data.resultData.page,
                    ps: data.resultData.pageSize,
                    total: data.resultData.total,
                };
                setPagevalue(pagevalue);
            } else {
                setLoadingDetail(false);
            }
        } catch (error) {
            setLoadingDetail(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Get ROPA
    const getRopa = useCallback(async (params) => {
        setLoadingDetail(true);
        setDataflowRopa([]);
        try {
            const { data } = await DsInquiryService.getRopa(params);
            if (data?.resultData) {
                setDataflowRopa(data.resultData.result);
                setLoadingDetail(false);
                const pagevalue = {
                    p: data.resultData.page,
                    ps: data.resultData.pageSize,
                    total: data.resultData.total,
                };
                setPagevalue(pagevalue);
            } else {
                setLoadingDetail(false);
            }
        } catch (error) {
            setLoadingDetail(false);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Get data flow ROPA
    const getDataFlowRopa = useCallback(async (params) => {
        setLoadingDetail(true);
        setDataflowRopa([]);
        try {
            const { data } = await DsInquiryService.getDataFlowRopa(params);
            if (data?.resultData) {
                setDataflowRopa(data.resultData.result);
                setLoadingDetail(false);
                const pagevalue = {
                    p: data.resultData.page,
                    ps: data.resultData.pageSize,
                    total: data.resultData.total,
                };
                setPagevalue(pagevalue);
            } else {
                setLoadingDetail(false);
            }
        } catch (error) {
            setLoadingDetail(false);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Get status
    const getStatus = useCallback(
        async (type = 'data-flow') => {
            try {
                let lang = i18n.language;
                const { data } = await DataFlowService.getStatus({
                    type,
                });
                if (data?.resultData) {
                    const options = data?.resultData?.map((element) => {
                        return {
                            label:
                                lang === 'en' ? element.nameEn : element.nameTh,
                            value: element.statusId,
                        };
                    });
                    // Add all option
                    options.unshift({
                        label: lang === 'en' ? 'All Status' : 'ทุกสถานะ',
                        value: 'all',
                    });
                    if (type === 'data-flow') {
                        setStatus(options);
                    } else {
                        setStatusRopa(options);
                    }
                }
            } catch (err) {
                console.log(err);
            }
        },
        [i18n.language]
    );

    // Get department
    const getDepartment = useCallback(async () => {
        try {
            let lang = i18n.language;
            const params = {
                s: lang === 'en' ? 'nameEn' : 'nameTh',
            };
            const { data } = await DataFlowService.getDepartmentList(params);
            if (data?.resultData) {
                const options = data?.resultData?.map((element) => {
                    return {
                        label: lang === 'en' ? element.nameEn : element.nameTh,
                        value: element.departmentId,
                    };
                });
                // Add all option
                options.unshift({
                    label: lang === 'en' ? 'All Department' : 'ทุกแผนก',
                    value: 'all',
                });
                setDepartment(options);
            }
        } catch (err) {
            console.log(err);
        }
    }, [i18n.language]);

    // Date String format DD-MM-YYYY
    const date_string = new Date()
        .toLocaleDateString('en-GB')
        .split('/')
        .join('-');

    // Export data flow
    const exportDataFlow = useCallback(
        async (params) => {
            setLoadingExport(true);
            try {
                const { data } = await DsInquiryService.exportDataFlow(params);
                if (data) {
                    setLoadingExport(false);
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        `Data_Inquiry_DS-DataFlow_${date_string}.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();
                }
            } catch (error) {
                setLoadingExport(false);
                console.log(error);
            }
        },
        [date_string]
    );

    // Export ROPA
    const exportRopa = useCallback(
        async (params) => {
            setLoadingExport(true);
            try {
                const { data } = await DsInquiryService.exportRopa(params);
                if (data) {
                    setLoadingExport(false);
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        `Data_Inquiry_DS-RoPA_${date_string}.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();
                }
            } catch (error) {
                setLoadingExport(false);
                console.log(error);
            }
        },
        [date_string]
    );

    // Export data flow ROPA
    const exportDataFlowRopa = useCallback(
        async (params) => {
            setLoadingExport(true);
            try {
                const { data } = await DsInquiryService.exportDataFlowRopa(
                    params
                );
                if (data) {
                    setLoadingExport(false);
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        `Data_Inquiry_Personal_Data_${date_string}.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();
                }
            } catch (error) {
                setLoadingExport(false);
                console.log(error);
            }
        },
        [date_string]
    );

    useEffect(() => {
        if (hash === '#ropa') getStatus('ropa-activity');
        else getStatus();
        getDepartment();
    }, [getDepartment, getStatus, hash]);

    return {
        status,
        statusRopa,
        department,
        loading,
        loadingDetail,
        dataSubject,
        dataflowRopa,
        loadingExport,
        getDataFlow,
        getRopa,
        getDataSubject,
        getCategoryPersonalData,
        getDataFlowRopa,
        exportDataFlow,
        exportRopa,
        exportDataFlowRopa,
    };
}
